"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var util_1 = require("./util");
function shallowDifferent(prev, next) {
    var different;
    if (isArray(next) && isArray(prev)) {
        different = next.reduce(function (shd, a, idx) {
            return shd || !util_1.shallowEqual(a, prev[idx]);
        }, false);
    }
    else {
        different = !util_1.shallowEqual(prev, next);
    }
    return different;
}
function prependArg(fn, arg) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fn.apply(void 0, __spreadArrays([arg], args));
    };
}
var isArray = Array.isArray;
/**
 * A component that its `constructor`, `shouldComponentUpdate`, and lifecycle methods
 * can be assigned via props
 */
var Bare = /** @class */ (function (_super) {
    __extends(Bare, _super);
    function Bare(props, ctx) {
        var _this = _super.call(this, props, ctx) || this;
        _this.previousPuritySource = null;
        var constructor = props.constructor, pureBy = props.pureBy, didCatch = props.didCatch, didMount = props.didMount, didUpdate = props.didUpdate, shouldUpdate = props.shouldUpdate, willUnmount = props.willUnmount;
        _this.self = _this;
        // make setState usable inside the constructor
        var originalSetState = _this.setState.bind(_this);
        if (util_1.isFunction(constructor)) {
            _this.setState = function (updater, callback) {
                _this.state = util_1.isFunction(updater) ? updater({}) : updater;
                if (util_1.isFunction(callback)) {
                    callback();
                }
            };
            constructor(_this, props, ctx);
        }
        _this.setState = originalSetState.bind(_this);
        _this.forceUpdate = _this.forceUpdate.bind(_this);
        if (util_1.isFunction(didCatch)) {
            _this.componentDidCatch = prependArg(didCatch, _this);
        }
        if (util_1.isFunction(didMount)) {
            _this.componentDidMount = prependArg(didMount, _this);
        }
        if (util_1.isFunction(didUpdate)) {
            _this.componentDidUpdate = function (_, prevState) { return didUpdate(_this, prevState); };
        }
        if (pureBy !== void 0) {
            if (shouldUpdate !== void 0) {
                throw new Error('You can only use either `shouldUpdate`, or `pureBy` prop in Bare components');
            }
            _this.previousPuritySource = pureBy;
            _this.shouldComponentUpdate = function shouldComponentUpdate(nextProps, _) {
                var nextPuritySource = nextProps.pureBy;
                var previousPuritySource = this.previousPuritySource;
                var should = shallowDifferent(nextPuritySource, previousPuritySource);
                if (should) {
                    this.previousPuritySource = nextPuritySource;
                }
                return should;
            };
        }
        else if (util_1.isFunction(shouldUpdate)) {
            _this.shouldComponentUpdate = function (_, nextState) { return shouldUpdate(_this, nextState); };
        }
        if (util_1.isFunction(willUnmount)) {
            _this.componentWillUnmount = prependArg(willUnmount, _this);
        }
        return _this;
    }
    Bare.prototype.render = function () {
        return util_1.toElement(this.props.render, this);
    };
    return Bare;
}(React.Component));
exports.Bare = Bare;
Bare.propTypes = {
    render: PropTypes.any.isRequired,
    constructor: PropTypes.func,
    pureBy: PropTypes.any,
    didCatch: PropTypes.func,
    didMount: PropTypes.func,
    didUpdate: PropTypes.func,
    shouldUpdate: PropTypes.func,
    willUnmount: PropTypes.func
};
//# sourceMappingURL=bare.js.map